import { render, staticRenderFns } from "./UserAddressSection.vue?vue&type=template&id=4276aa27&scoped=true&lang=pug"
import script from "./UserAddressSection.vue?vue&type=script&lang=js"
export * from "./UserAddressSection.vue?vue&type=script&lang=js"
import style0 from "./UserAddressSection.vue?vue&type=style&index=0&id=4276aa27&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4276aa27",
  null
  
)

export default component.exports